(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eps-color-gallery"] && !Shopify.designMode) return;
  try {
    class EpsColorGallery extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector('[data-eps-color-gallery-open]');
      this.closeButton = this.querySelector('[data-eps-color-gallery-close]');
      this.dialog = this.querySelector('[data-eps-color-gallery-dialog]');

      this.openButton?.addEventListener('click', this.open);
      this.closeButton?.addEventListener('click', this.close);
      this.dialog?.addEventListener('click', this.closeFromBackdrop);
      this.dialog?.addEventListener('click', this.selectColor);
      this.dialog?.addEventListener('keydown', this.selectColorOnKey);
    }

    disconnectedCallback() {
      this.openButton?.removeEventListener('click', this.open);
      this.closeButton?.removeEventListener('click', this.close);
      this.dialog?.removeEventListener('click', this.closeFromBackdrop);
      this.dialog?.removeEventListener('click', this.selectColor);
      this.dialog?.removeEventListener('keydown', this.selectColorOnKey);
    }

    open = () => {
      this.dialog?.showModal();
    };

    close = () => {
      this.dialog?.close();
    };

    closeFromBackdrop = (event) => {
      if (event.target === this.dialog) this.close();
    };

    #getScopedVariantPicker() {
      const productComponent = this.closest('product-component');

      if (productComponent) {
        const picker = productComponent.querySelector('variant-picker');
        if (picker) return picker;
      }

      const ancestorPicker = this.closest('variant-picker');
      if (ancestorPicker) return ancestorPicker;

      return null;
    }

    selectColor = (event) => {
      const item = event.target.closest('[data-option-value-id]');
      if (!item || item === this.dialog) return;

      const optionValueId = item.dataset.optionValueId;
      if (!optionValueId) return;

      const picker = this.#getScopedVariantPicker();
      if (!picker) return;

      const radio = picker.querySelector(
        `input[type="radio"][data-option-value-id="${optionValueId}"]`
      );
      if (!radio) return;

      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));

      this.close();
    };

    selectColorOnKey = (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const item = event.target.closest('[data-option-value-id]');
      if (!item) return;

      event.preventDefault();
      item.click();
    };
  }

  if (!customElements.get('eps-color-gallery')) {
    customElements.define('eps-color-gallery', EpsColorGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
